<template>
  <v-flex>
    <v-layout
      row
      wrap
      align-center
      v-if="checkDependency(fields['@attributes'])"
    >
      <v-layout align-center v-if="checkAccessMode(fields)">
        <v-flex xs1 md1>
          <v-btn
            @click="openHelpDialog(fields['@attributes'].helptxtid)"
            flat
            icon
            class="ma-0 help-ico"
          >
            <svg
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              fit
              height="100%"
              width="100%"
              preserveAspectRatio="xMidYMid meet"
              focusable="false"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
              />
            </svg>
          </v-btn>
        </v-flex>

        <v-flex xs7 md7>
          <span class="subheading title-boil">
            <span>{{ fields["@attributes"].txtid | translate }}</span>
            <span v-if="fields['@attributes'].unittxt">
              ({{ fields["@attributes"].unittxt | translate }})
            </span>
          </span>
        </v-flex>
        <v-flex xs4 md4>
          <v-text-field
            v-if="fields['@attributes'].type === 'text' && checkField()"
            class="mt-0 pt-0"
            :readonly="checkReadOnly() ? true : false"
            :disabled="checkReadOnly() ? true : false"
            :value="subMenuData.val"
            @click.native="
              checkReadOnly() ? null : chooseDialog(fields['@attributes'])
            "
            @keydown="
              checkReadOnly() ? null : chooseDialog(fields['@attributes'])
            "
          ></v-text-field>
          <v-text-field
            v-if="fields['@attributes'].type === 'password' && !checkField()"
            type="password"
            class="mt-0 pt-0"
            :readonly="checkReadOnly() ? true : false"
            :disabled="checkReadOnly() ? true : false"
            :value="subMenuData.val"
            @click.native="
              checkReadOnly() ? null : chooseDialog(fields['@attributes'])
            "
            @keydown="
              checkReadOnly() ? null : chooseDialog(fields['@attributes'])
            "
          ></v-text-field>
          <v-text-field
            v-if="fields['@attributes'].type === 'text' && !checkField()"
            :class="
              fields['@attributes'].auth === 'nbe'
                ? 'mt-0 pt-0 red-access'
                : 'mt-0 pt-0'
            "
            :readonly="checkReadOnly() ? true : false"
            :disabled="checkReadOnly() ? true : false"
            :value="subMenuData.val | tempConversion"
            @click.native="
              checkReadOnly() ? null : chooseDialog(fields['@attributes'])
            "
            @keydown="
              checkReadOnly() ? null : chooseDialog(fields['@attributes'])
            "
          ></v-text-field>
          <v-text-field
            v-if="
              fields['@attributes'].type === 'countdowntimer' && !checkField()
            "
            :class="
              fields['@attributes'].auth === 'nbe'
                ? 'mt-0 pt-0 red-access'
                : 'mt-0 pt-0'
            "
            :readonly="checkReadOnly() ? true : false"
            :disabled="checkReadOnly() ? true : false"
            :value="subMenuData.val"
            @click.native="
              checkReadOnly() ? null : chooseDialog(fields['@attributes'])
            "
            @keydown="
              checkReadOnly() ? null : chooseDialog(fields['@attributes'])
            "
          ></v-text-field>
          <v-btn
            class="timer-btn"
            v-if="
              fields['@attributes'].type === 'timer' ||
                fields['@attributes'].type === 'time_selection'
            "
            :disabled="checkReadOnly()"
            @click="$emit('openTimerComponent')"
            small
            >{{ fields["@attributes"].txtid | translate }}</v-btn
          >
          <v-btn
            class="timer-btn"
            v-if="
              fields['@attributes'].type === 'clear' ||
                fields['@attributes'].type === 'timer_minutes'
            "
            :disabled="checkReadOnly()"
            small
            @click="openButtonDialog"
            >{{ fields["@attributes"].btntxt | translate }}</v-btn
          >
          <v-btn
            class="timer-btn"
            v-if="fields['@attributes'].type === 'weather_time_selection'"
            :disabled="checkReadOnly()"
            small
            @click="$emit('openWeatherTimerComponent')"
            >{{ fields["@attributes"].btntxt | translate }}</v-btn
          >
          <v-btn
            class="timer-btn"
            v-if="fields['@attributes'].type === 'extheat_table'"
            :disabled="checkReadOnly()"
            @click="openHeatTimerPage"
            small
            >{{ fields["@attributes"].txtid | translate }}</v-btn
          >
          <v-select
            :readonly="checkReadOnly() ? true : false"
            :disabled="checkReadOnly() ? true : false"
            @click.native="
              !checkReadOnly() && false
                ? openTechDialog()
                : saveSelectFieldUdp(fields['@attributes'].udp)
            "
            v-if="
              fields['@attributes'].type === 'dropdown' &&
                selectfieldData &&
                fields['@attributes'].fieldset !== 'outputs_ext' && fields['@attributes'].fieldset !== 'outputs_no_ext'
            "
            class="mt-0 pt-0"
            :items="selectfieldData"
            :value="selectedSelectField[fields['@attributes'].fieldset].val"
            item-text="name"
            item-value="value"
            menu-props="auto"
            return-object
            @change="saveSelectFieldParent"
          ></v-select>
          <v-select
            :readonly="checkReadOnly() ? true : false"
            :disabled="checkReadOnly() ? true : false"
            @click.native="
              !checkReadOnly() && false
                ? openTechDialog()
                : saveSelectFieldUdp(fields['@attributes'].udp)
            "
            v-if="
              fields['@attributes'].type === 'dropdown' &&
                selectfieldData &&
                (fields['@attributes'].fieldset === 'outputs_ext' || fields['@attributes'].fieldset === 'outputs_no_ext')
            "
            class="mt-0 pt-0"
            :items="modifyAlarmSelectField(selectfieldData)"
            :value="selectedSelectField[fields['@attributes'].fieldset].val"
            item-text="extenedName"
            item-value="value"
            menu-props="auto"
            return-object
            @change="saveSelectFieldParent"
          >
            <template v-slot:selection="{ item }">
              <span>{{ item.name }}</span>
            </template>
            <template v-slot:item="{ item }">
              <span v-if="item.extenedName">{{ item.extenedName }}</span>
              <span v-else>{{ item.name }}</span>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
    </v-layout>
    <help-dialog
      :help-text="selectedHelpText"
      :openDialog="helpDialog"
      :closeDialog="closeHelpDialog"
    ></help-dialog>
    <tech-access-dialog
      :openDialog="techDialog"
      :closeDialog="closeTechDialog"
      :giveAccess="giveTechAccess"
    ></tech-access-dialog>
    <tech-access-dialog
      :messageText="buttonText"
      :openDialog="buttonDialog"
      :closeDialog="closeButtonDialog"
      :giveAccess="chooseButtonAction"
    ></tech-access-dialog>
  </v-flex>
</template>

<script>
import { mapGetters } from "vuex";
import GlobalService from "../services/global-service";
import HelpDialog from "./HelpDialog";
import TechAccessDialog from "./TechAccessDialog";
import { translate } from "../common/HelperFunctions";
import router from "../router.js";

export default {
  name: "FieldItem",
  data() {
    return {
      dialog: false,
      selectedField: undefined,
      selectedFieldUdp: undefined,
      selectedFieldText: "",
      selectedFieldDesc: "",
      selectField: {},
      selectfieldData: [],
      selectedSelectField: {},
      helpDialog: false,
      selectedHelpText: "",
      techDialog: false,
      buttonDialog: false,
      buttonText: "lng_smith_warning"
    };
  },
  components: {
    HelpDialog,
    TechAccessDialog
  },
  props: {
    fields: {
      type: Object,
      default: () => {}
    },
    subMenuData: {
      type: Object,
      default: () => {}
    },
    subMenuSelectData: {
      type: Object,
      default: () => {}
    },
    udpDependency: {
      type: Object,
      default: () => {}
    },
    subMenuOutputSetting: {
      type: Array,
      default: () => []
    },
    showHelpdialog: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    subMenuData: function(newVal) {
      if (
        this.fields["@attributes"].type === "countdowntimer" &&
        newVal.val > 0
      ) {
        this.countdownTimer(newVal.val);
      }
    }
  },
  created() {
    this.selectFieldsInitialize();
    this.selectedFieldsInitialize();
  },
  mounted() {},
  computed: {
    ...mapGetters("user", ["getUser"]),
    ...mapGetters("global", ["getTechAccess"]),
    ...mapGetters("global", ["getAccessMode"]),
    readOnly() {
      const paymentenabled = localStorage.getItem('paymentenabled');
      const expiryFlag = localStorage.getItem('expiryFlag');
      if(paymentenabled && expiryFlag == 0){
        return true
      }
      return this.getUser.credentials === "readonly";
    },
    getLanguage() {
      return localStorage.getItem("language");
    }
  },
  methods: {
    checkAccessMode(field) {
      let status = false;
      if (!field["@attributes"].auth) {
        status = true;
      } else if (
        field["@attributes"].auth === "smith" &&
        this.getAccessMode === "smith"
      ) {
        status = true;
      } else if (this.getAccessMode === "nbe") {
        status = true;
      }
      return status;
    },
    checkField() {
      return (
        this.fields["@attributes"].udp === "notify.email" ||
        this.fields["@attributes"].udp === "notify.phone"
      );
    },
    // check field's readability
    checkReadOnly() {
      if (window.location.pathname === "/system/screen" || window.location.pathname === "/system/settings") {
        return false;
      }
      return this.readOnly || this.fields["@attributes"].readonly;
    },
    // check the udpdependency of field
    checkDependency(field) {
      if (field.visibility === "hidden") return false;
      else if (!field.udpdependency) {
        return true;
      } else if (
        this.udpDependency.val &&
        field.udpdependencyvalue === this.udpDependency.val
      ) {
        return true;
      }
      return false;
    },
    openHelpDialog(helpText) {
      this.selectedHelpText = translate(helpText);
      this.helpDialog = true;
    },
    // close Help text showing dialog
    closeHelpDialog() {
      this.helpDialog = false;
    },
    // open technical access dialog
    openTechDialog() {
      this.techDialog = true;
    },
    // close technical access dialog
    closeTechDialog() {
      this.techDialog = false;
    },
    // save technical access given
    giveTechAccess() {
      this.$store.commit("global/setTechAccess", true);
      this.techDialog = false;
    },
    // open Clear Ignition dialog
    openButtonDialog() {
      this.buttonText =
        this.fields["@attributes"].type === "clear"
          ? "lng_clear_warning"
          : this.fields["@attributes"].helptxtid;
      this.buttonDialog = true;
    },
    // close Clear Ignition dialog
    closeButtonDialog() {
      this.buttonDialog = false;
    },
    saveSelectFieldParent(fieldData) {
      this.$emit("saveSelectFieldData", fieldData);
    },
    chooseButtonAction() {
      if (this.fields["@attributes"].type === "clear")
        this.clearButtonData(
          "ignition",
          "ignition.ignition_number",
          this.subMenuData.val
        );
      else if (this.fields["@attributes"].type === "timer_minutes")
        this.clearButtonData("hopper", this.fields["@attributes"].udp, 360);
    },
    async clearButtonData(menu, name, val) {
      this.buttonDialog = false;
      let response;
      try {
        response = await GlobalService.saveFieldData(
          menu,
          name,
          this.getUser.token,
          val
        );
      } catch (e) {
        var resObj = { status: 1, message: "Try again later" };
        this.$emit("showResponseAlert", resObj);
      }
      if (response.status === "0") {
        this.$emit("showResponseAlert", response);
      } else {
        this.$emit("showResponseAlert", response);
      }
      // this.$emit("saveSelectFieldData", this.subMenuData);
    },
    // function to check field's auth
    checkFieldAccess(field) {
      return field.auth === "smith" || field.auth === "nbe"
        ? !this.getTechAccess
        : false;
    },
    // function to show dialog either technical access or update field's range slider
    chooseDialog(field) {
      this.$emit("openRangeSliderDialog", this.subMenuData);
    },
    // to call a function in parent
    saveSelectFieldUdp(udp) {
      this.$emit("saveSelectFieldUdp", udp);
    },
    // initilization of dropdown field values
    selectFieldsInitialize() {
      let selectFieldOptions = [];
      if (this.subMenuSelectData.field) {
        for (let i = 0; i < this.subMenuSelectData.field.length; i++) {
          selectFieldOptions.push({
            name: translate(
              this.subMenuSelectData.field[i]["@attributes"].txtid
            ),
            value: this.subMenuSelectData.field[i]["@attributes"].value
          });
        }
      }
      this.selectfieldData = selectFieldOptions;
    },
    // a function to store the selected field of dropdown
    selectedFieldsInitialize() {
      let selectedFieldsdata = {};
      if (this.fields["@attributes"].type === "dropdown") {
        if (!this.subMenuData) {
          selectedFieldsdata[this.fields["@attributes"].fieldset] = {
            factor: 1,
            max: -1,
            min: -1,
            val: "0"
          };
        } else {
          selectedFieldsdata[
            this.fields["@attributes"].fieldset
          ] = this.subMenuData;
        }
      }
      this.selectedSelectField = selectedFieldsdata;
    },
    // a function to append the extra string and actions to Alarm Output dropdown
    modifyAlarmSelectField(fields) {
      fields.forEach((f, index) => {
        this.subMenuOutputSetting.forEach(val => {
          if (parseInt(f.value) === val.id && index > 0) {
            f.extenedName =
              val.txt !== "" ? f.name + "(" + translate(val.txt) + ")" : f.name;
            f.disabled = true;
          }
        });
      });
      return fields;
    },
    countdownTimer(countDownTime) {
      let time = countDownTime * 1000;
      let that = this;
      this.intervalInstance = setInterval(function() {
        time = time - 1000; //reduce each second
        that.subMenuData.val = (time / 1000) % 60;
        if (that.subMenuData.val <= 0) {
          clearInterval(that.intervalInstance);
        }
      }, 1000);
    },
    openHeatTimerPage() {
      router.push(`/ext-energy/costing`);
    }
  }
};
</script>

<style>
.red-access.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #f44336;
  cursor: pointer;
}
</style>
